<tt-page>
    <tt-page-heading *ngIf="!!setting && !!setting.emailcreate_heading" [ttModel]="setting.emailcreate_heading" ttTranslate="false"></tt-page-heading>

    <div class="col-xs-12 col-md-4 sp-0">
        <tt-card>
            <tt-button-goto ttText="create_new_person" ttGoto="person" [ttGotoParms]="{ cust_no: custNo, pers_no: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListCustomerPersons"></tt-list>
    </div>
</tt-page>
